export const MODULE_NAME = 'connectivity';
export const DEFAULT_REQUEST_TIMEOUT_MS = 60000;
